import { Tooltip } from "@mui/material";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import ServiceCategoryTooltip from "./ServiceCategoryTooltip";
import { tooltipContent as defaultTooltipContent } from "../utils/constants";
import {
  FOUNDATION_ALL_RFI_NAME,
  isFoundationAllLabel,
} from "../utils/foundationScope";
import { getRfiCapabilityBadgeDisplayName } from "../utils/rfiCatalogServiceNames";

const foundationTooltipSx = {
  backgroundColor: "#555555",
  color: "white",
  fontSize: "1rem",
};

/** VQA Scope fallback when the document has no capabilities list. */
export function DefaultFoundationScopeBadge({
  tooltipContent = defaultTooltipContent,
}) {
  return (
    <div
      className="inline-flex items-center rounded px-2 py-1 text-xs font-medium bg-green-50 text-green-700"
      style={{ boxShadow: "inset 0 0 0 1px rgba(21,128,61,0.1)" }}
    >
      {FOUNDATION_ALL_RFI_NAME}
      <Tooltip
        title={tooltipContent}
        arrow
        placement="bottom"
        sx={foundationTooltipSx}
      >
        <span>
          <InformationCircleIcon className="w-5 h-5 text-center ml-2" />
        </span>
      </Tooltip>
    </div>
  );
}

/** Single RFI document Scope badge (Foundation tooltip vs catalog tooltip). */
export default function SingleDocumentScopeBadge({
  documentName,
  badgeStyle = {},
  tooltipContent = defaultTooltipContent,
  roundedClassName = "rounded-md",
}) {
  const displayName = getRfiCapabilityBadgeDisplayName(documentName);

  return (
    <div
      className={`inline-flex items-center ${roundedClassName} px-2 py-1 text-xs font-medium`}
      style={{
        backgroundColor: badgeStyle.bgColor,
        boxShadow: `inset 0 0 0 1px ${badgeStyle.borderColor}1A`,
        color: badgeStyle.textColor,
      }}
    >
      {displayName}
      {isFoundationAllLabel(documentName) ? (
        <Tooltip
          title={tooltipContent}
          arrow
          placement="bottom"
          sx={foundationTooltipSx}
        >
          <span>
            <InformationCircleIcon className="w-5 h-5 text-center ml-2" />
          </span>
        </Tooltip>
      ) : (
        <ServiceCategoryTooltip name={displayName} />
      )}
    </div>
  );
}
